import React from 'react'
import { getTranslatedTextByKey } from 'utils/utils'
import { Logo } from 'components/common/Logo'
import { ERROR_IMAGE_ROUTE } from 'utils/staticFilesRoutes'
import {
	ErrorPageContainer,
	ErrorPageContentImage,
	ErrorPageOneButtonHeader,
	CHAIN_SHUT_DOWN_SUBTITLE,
	CHAIN_SHUT_DOWN_TITLE,
} from 'static/components/errors/ErrorPagesSharedComponents'
import { getThemeUrl } from 'utils/theme/themeManager'
import type { RouteComponentProps } from 'react-router-dom'
import { THEME_STRATEGY } from 'constants/theme'
import { inject, observer } from 'mobx-react'
import type _Infra from 'mobx/Infra'
import styled from 'styled-components'
import TypographyPro from 'themes/TypographyPro'

const Header = styled(ErrorPageOneButtonHeader)`
	justify-content: center;
`

const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 70%;
	max-width: calc(1280px * 0.7);
	text-align: center;
	min-height: calc(100vh - 80px);

	@media (max-width: 576px) {
		width: 85%;
		margin: 15px 20px 0px;
	}
`

const Title = styled(TypographyPro)`
	margin-top: 40px;
	color: var(--strokeMenuTitle);

	@media (max-width: 959px) {
		margin-top: 15px;
	}
`

const SubTitle = styled(TypographyPro)`
	color: var(--fonts);
	margin-top: 5px;
`

interface ChainShutDownErrorPageProps {
	Infra: typeof _Infra
}

const ChainShutDownErrorPage = inject('Infra')(
	observer(({ Infra }: ChainShutDownErrorPageProps & RouteComponentProps) => {

		const { theme, c: chainId, brand } = Infra.appParams
		const imgPath = `${getThemeUrl(theme || THEME_STRATEGY.GENERIC, chainId, brand)}/assets`

		return (
			<ErrorPageContainer>
				<Header>
					<Logo />
				</Header>
				<Content>
					<ErrorPageContentImage src={`${imgPath}${ERROR_IMAGE_ROUTE}`} alt="error image" />
					<Title variant="h2" component="h2">
						{getTranslatedTextByKey('eCommerce.errorPages.chainShutDownTitle', CHAIN_SHUT_DOWN_TITLE)}
					</Title>
					<SubTitle variant="SubheadHighlighted">
						{getTranslatedTextByKey('eCommerce.errorPages.chainShutDownSubtitle', CHAIN_SHUT_DOWN_SUBTITLE)}
					</SubTitle>
				</Content>
			</ErrorPageContainer>
		)
	})
)

export default ChainShutDownErrorPage
